module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	
	fox.registerWidget('Catalog3X_VR', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					events: {
						widget: 'Catalog_List_VR'
					},
					subscribeVR: {
						widget: 'Model_VR_Subscription'
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Catalog3X_Latest');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/catalog/catalog3x/vllist.js
// module id = 125
// module chunks = 0